import { render, staticRenderFns } from "./reserved.vue?vue&type=template&id=39f7c958&"
import script from "./reserved.vue?vue&type=script&lang=js&"
export * from "./reserved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39f7c958')) {
      api.createRecord('39f7c958', component.options)
    } else {
      api.reload('39f7c958', component.options)
    }
    module.hot.accept("./reserved.vue?vue&type=template&id=39f7c958&", function () {
      api.rerender('39f7c958', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/reserved.vue"
export default component.exports